<template lang='pug'>
//- 取得免費VIP訂閱
div(:class='$style[`cc-popbox-trail`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='再想一下'
      tabindex='0'
      @click='handleClosePopBox')

  div(:class='$style[`cc-content-banner`]')
    figure(:class='$style[`cc-content-banner-graph`]')
      img(:src='`${SERVER_STATIC_URL}media/news/trail.webp`' width='100%')

  div(:class='$style[`cc-content-new`]')
    //- span.font-bold(:class='$style[`cc-content-new-info`]') {{ describeInfo }}
    span.font-medium(:class='$style[`cc-content-new-info`]') * 啟用後無法取消，請確認後再點擊【立即啟用】按鈕。

    div(:class='$style[`cc-content-btn-area`]')
      button.btn-extra(
        title='再想一下'
        aria-label='再想一下'
        tabindex='0'
        :class='$style[`cc-content-btn`]'
        @click='handleClosePopBox')
        span 再想一下

      button.btn-black-extra(
        title='啟用14天免費訂閱'
        aria-label='啟用14天免費訂閱'
        tabindex='0'
        :class='[$style[`cc-content-btn`], $style[`cc-content-receive-btn`]]'
        @click='handleClickStartTrail')
        span 立即啟用

</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import GlobalEmitter from 'tiny-emitter/instance';
// import axios from 'axios';
import {
  putReceiveTrailSubscribe,
} from '../../../js/restapi';

export default {
  // data() {
  //   return {
  //   };
  // },

  methods: {
    ...mapMutations({
      changePopFreeTrailStatus: 'global/POPFREETRAIL_STATUS',
      changePopBoxStatus: 'global/POPBOX_STATUS',
    }),

    handleClosePopBox() {
      this.changePopFreeTrailStatus({
        active: false,
      });
    },

    handleClickStartTrail() {
      if (!this.loginProfile.verified && this.loginProfile.email) {
        this.changePopBoxStatus({
          active: true,
          include: 'needVerify',
        });
      } else {
        putReceiveTrailSubscribe('', {})
          .then((res) => {
            if (res.data === 'trail subscribe') {
              this.changePopFreeTrailStatus({
                active: false,
              });

              this.changePopBoxStatus({
                active: true,
                include: 'sendConfirmFreeVip',
              });
              setTimeout(() => {
                this.changePopBoxStatus({
                  active: false,
                  include: '',
                });

                // 更新User Store State
                GlobalEmitter.emit('force-root-update', {
                  event: 'userProfile-refresh',
                });
                // this.$router.go(this.$router.currentRoute);
              }, this.POP_DURATION);
            } else if (res.data === 'trail received') {
              this.changePopBoxStatus({
                active: true,
                include: 'warnError',
              });
            }
          })
          .catch((err) => {
            console.log('err', err);
          });
      }
    },
  },

  computed: {
    ...mapGetters({
      loginDjangoId: 'user/exportUserDjangoId',
      loginProfile: 'user/exportUserProfile',
      // subscribeVip: 'user/exportUserSubscribeVip',
      // authJwtToken: 'user/exportUserJwtToken',
    }),
  }
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popFreeTrail.scss';
</style>
